var XPortal = XPortal || {};

XPortal.SectionExpandCollapse = (function () {
    const self = {
        _section: 'xsection',
        _sectionSelector: '.xsection',
        summaryTextSelector: '.collapse-summary-text',
        summarySelector: '.collapse-summary',
        expandCollapseAttributeName: 'data-expand-collapse',
        maximizeAttributeName: 'data-maximize',
        collapseWithAnimationClass: 'collapse-with-animation',
        minWa: 50,
        modelStateChangeSubscription: null,
        updateSectionsTimeout: null,
        Init: function (selector) {
            const $container = $(selector ? selector : "body");
  
            self.applyTemplateSummariesTexts($container);
            self.subscribeForModelChanges($container);

            $(document).off('clientWidthChanged.sectionExpandCollapse')
                .on('clientWidthChanged.sectionExpandCollapse', function () {
                    self.RefreshViewportBreakpoint($("body"));
                });
        },
        InitFor: function (section, sttgs) {
            if (!sttgs || !section) return;
            var $header = section.children().children('.block-header');
            sttgs.hasHeader = !!$header.length;
            sttgs = getClpOptions(section, sttgs);
            initCollapsing(section, sttgs);
            initMaximizing(section, sttgs);
        },
        applyTemplateSummariesTexts: function ($container) {
            $container.find(self.summaryTextSelector).each(function () {
                self.applyTemplateSummaryText($(this));
            });
        },
        applyTemplateSummaryText: function ($collapseSummary) {
            const summaryModel = getReplacedModel($collapseSummary);
            if (justStaticContent(summaryModel.replaceContext))
                htmlTemplate = "";
            $collapseSummary.html(summaryModel.replacedText);
        },
        RefreshViewportBreakpoint: function ($container) {
            const newPrefix = XPortal.Utils.getViewportName();
            const $sections = $container.find(self._sectionSelector);

            $sections.each(function () {
                const context = $(this).data('h-collapse-context');
                if (!context) {
                    return;
                }
                const cllpsg = context.cllpsg;
                if (!cllpsg || !cllpsg.IsEnabled || !cllpsg.Setup || cllpsg.Setup.Mode === 'vertical') {
                    return;
                }
                if (cllpsg.viewportPrefix === newPrefix) {
                    return;
                }

                cllpsg.viewportPrefix = newPrefix;
                initCollapsingHContext(context, true);
                refreshCollapsingHItems(context);
            });
        },
        subscribeForModelChanges: function ($container) {
            if (XPortal["Store"] && XPortal["Store"]["AppStore"]) {
                const store = XPortal.Store.AppStore;

                self.modelStateChangeSubscription = self.modelStateChangeSubscription || store.subscribe(() => {
                    var lastAction = store.getState().lastAction;
                    if (lastAction.type != XPortal.Redusers.ACTIONS.EDIT_FIELD)
                        return;
                    if (self.updateSectionsTimeout) clearTimeout(self.updateSectionsTimeout);
                    self.updateSectionsTimeout = setTimeout(() => {
                        self.applyTemplateSummariesTexts($container);
                    }, 300);
                });
                return true;
            } else return false;
        }
    };
    function getReplacedModel($collapseSummary) {
        let entityData = { Fields: [] };
        const $embedDetail = $collapseSummary.closest("div[id^='embed-detail-c']");
        const $form = $embedDetail.length ? $embedDetail : $(XPortal.Main.DetialFormSelector);
        if ($form && $form.length) {
            const formId = $form.attr("id");
            const modelName = formId && formId.indexOf && formId.indexOf("_") ? XPortal.Store.getModelName(formId) : XPortal.Store.getModelName($form);
            let model = XPortal.Store.GetBaseReduserState().pageModels[modelName];
            if (model) entityData = Object.assign(entityData, model.entity);
        }
        entityData = XPortal.Grid.MapEntity(entityData, {});
        const replaceContext = { values: [], names: [] };
        let replacedText = XPortal.Template.TemplateToHtml(entityData, $collapseSummary.data("collapse-template"), null, null, null, replaceContext);
        return { replacedText, replaceContext }
    }
    function justStaticContent(context) {
        if (!context || !context.values || !context.values.length) return true;
        return !context.values.some(x => {
            if (typeof x === 'string') {
                return x.trim().length > 0;
            } else if (x.length > 0) {
                return true;
            }
            return false;
        });
    };
    function getClpOptions(section, sttgs, forceViewportRecalc) {
        const cpso = sttgs.Collapsing || (sttgs.Collapsing = {});
        const needsInit = !cpso.initalized;
        if (!needsInit && !forceViewportRecalc) return sttgs;

        if (needsInit) {
            cpso.initalized = true;
            cpso.isExpanded = (cpso.StartState || "").toLowerCase() !== 'collapsed';
            cpso.animationTime = cpso.Animated ? 300 : 0;
            cpso.offset = section.offset();
            cpso.relatedIds = [];
            cpso.originalClasses = section.attr('class');
            cpso.originalClasses = section.attr('class');
            cpso.designClasses = (cpso.originalClasses || '')
                .split(/\s+/)
                .filter(c => /^col-(xl|lg|md|sm|xs)-\d+$|^col-\d+$/.test(c));
        }

        cpso.viewportPrefix = XPortal.Utils.getViewportName();
        cpso.viewport = XPortal.Utils.getViewportStateForCurrentResolution(cpso.originalClasses, cpso.viewportPrefix);
        const startupVP = XPortal.Utils.getViewportStateByClasses(cpso.originalClasses);
        cpso.startupVPCss = XPortal.Utils.createViewportCssClasses(startupVP);
        if (!cpso.IsEnabled || !cpso.Setup) return sttgs;
        cpso.Setup.CollapsedCss = cpso.Setup.CollapsedCss && cpso.Setup.CollapsedCss.length ? cpso.Setup.CollapsedCss : "col-12";
        const collpsdVP = XPortal.Utils.getViewportStateByClasses(cpso.Setup.CollapsedCss);
        cpso.collpsdVPCss = XPortal.Utils.createViewportCssClasses(collpsdVP);
        cpso.collapsedViewport = XPortal.Utils.getViewportStateForCurrentResolution(cpso.Setup.CollapsedCss, cpso.viewportPrefix);
        cpso.isZeroLength = cpso.collapsedViewport === 12;
        cpso.collapsedViewportCss = XPortal.Utils.createViewportCssClass(cpso.viewportPrefix, cpso.collapsedViewport);

        return sttgs;
    };
    function initCollapsing(section, sttgs) {
        const cllpsg = sttgs.Collapsing || {};
        cllpsg.IsEnabled = cllpsg.IsEnabled && (cllpsg.Setup ? true : false);
        if (!cllpsg.IsEnabled) return cllpsg;
        const summary = section.children().children(self.summarySelector);
        const context = {
            nodeId: sttgs.nodeId,
            $item: section, cllpsg, header: section.children().children('.block-header'),
            summary, summaryE: summary.children(".expanded"), summaryC: summary.children(".collapsed"),
            content: section.children().children('.section-content'),
            btn: section.children().children('.collapse-buttons').find('.collapse-btn')
        };
        if (cllpsg.Setup.Mode == "vertical") {
            initCollapsingV(context);
        } else {
            initCollapsingH(context);
            section.data('h-collapse-context', context);
        }
        return cllpsg;
    };
    function initMaximizing(section, sttgs) {
        if (!sttgs.Maximizing || !sttgs.Maximizing.Enable) return;
        const maxsg = sttgs.Maximizing;
        const btns = section.children().children('.collapse-buttons').find('.maximize-btn');
        const context = {
            nodeId: sttgs.nodeId,
            $item: section, maxsg, header: section.children().children('.block-header'),
            content: section.children().children('.section-content'),
            btns, btnMax: btns.find('.m-max'), btnMin: btns.find('.m-min'),
            btnCollps: section.children().children('.collapse-buttons').find('.collapse-btn'),
            hasScheduler: section.children().children('.section-content').find('.scheduler-parent').length
        };
        context.btnMax.removeClass('ri-expand-').addClass(`ri-expand-${maxsg.Mode}`);
        context.btnMin.removeClass('ri-contract-').addClass(`ri-contract-${maxsg.Mode}`);

        btns.removeClass('d-none');
        const refreshSectionMinMax = function () {
            maxsg.isMaximized = !maxsg.isMaximized;
            refreshMinMax(context);
            XPortal.Main.RecalculateContentElementsSizes(section, 0);
            setTimeout(function () { section.trigger('maximized'); }, 100);
        };
        btns.on('click', refreshSectionMinMax);
        maxsg.isMaximized = !(maxsg.isMaximized ? true : false);
        refreshSectionMinMax();
    };
    function initCollapsingV(context) {
        const { cllpsg, summary, header, btn, $item } = context;
        if (cllpsg.Setup.SummaryPosition.indexOf("right") == 0) header.find('h2').append(summary);
        summary.removeClass('d-none');
        btn.removeClass('d-none');
        if (cllpsg.Setup.ArrowType != "right")
            btn.appendTo(header).wrap('<div class="collapse-buttons"></div>');

        const refreshCollapsingV = () => {
            cllpsg.isExpanded = !cllpsg.isExpanded;
            updateOverflowV('hide', context.content, context.summaryE, context.summaryC);
            const res = cllpsg.isExpanded
                ? animateVCollapsing.call(context, 'slideDown', 'slideUp')
                : animateVCollapsing.call(context, 'slideUp', 'slideDown');
            res.then(() => $item.trigger(cllpsg.isExpanded ? 'expanded' : 'collapsed'));
        };

        const excHeader = cllpsg.Setup.ArrowType != "right" ? header : btn.add(header);
        excHeader.on('click', (e) => {
            if (e.target.closest('.dropdown') || e.target.closest('.fs-summary-reset-button')) {
                return;
            }
            refreshCollapsingV();
            XPortal.DynamicFilters.updateSectionColStyleClasses();

        });
        cllpsg.isExpanded = cllpsg.StartState === 'Collapsed';
        refreshCollapsingV();
    };
    function initCollapsingH(context) {
        const { cllpsg, btn, $item } = context;
        btn.removeClass('d-none');

        initCollapsingHContext(context);
        const refreshCollapsingH = function (isInit) {
            cllpsg.isExpanded = !cllpsg.isExpanded;
            !isInit && $item.toggleClass('expanded').toggleClass('collapsed');
            initCollapsingHContext(context);
            context.isInit = isInit;
            refreshCollapsingHItems(context).then(() => $item.trigger(cllpsg.isExpanded ? 'expanded' : 'collapsed'));
        };
        btn.on("click", () => {
          refreshCollapsingH(false);
          if (window.innerWidth < 992) {
            $item.toggleClass("full-height", !$item.hasClass("collapsed"));
          }
        });

        cllpsg.isExpanded = !cllpsg.isExpanded;
        refreshCollapsingH(true);
    };
    function initCollapsingHContext(context, forceViewportRecalc) {
        const { cllpsg } = context;
        const all = [];
        let totalExpandView = 0;
        const parent = context.$item.parent();
        if (cllpsg.relatedIds.length) {
            cllpsg.relatedIds.forEach(x => {
                const $item = XPortal.SectionBlock.getBlockById(parent, x);
                const ioptsg = getClpOptions($item, XPortal.SectionBlock.getOptions($item), forceViewportRecalc);
                const iopts = ioptsg.Collapsing;
                totalExpandView = iopts.totalExpandView;
                all.push({ $item, iopts, ioptsg, nodeId: ioptsg.nodeId });
            });
            debug('---get-h-clps:' + context.nodeId + ', - rel:' + cllpsg.relatedIds.length, { all, cllpsg });
        } else {
            XPortal.SectionBlock.getBlocks(parent).each((xi, x) => {
                const $item = $(x);
                const ioptsg = getClpOptions($item, XPortal.SectionBlock.getOptions($item), forceViewportRecalc);
                const iopts = ioptsg.Collapsing;
                if (iopts.offset.top == cllpsg.offset.top) {
                    cllpsg.relatedIds.push(ioptsg.nodeId);
                    totalExpandView = (iopts.IsEnabled ? 0 : iopts.viewport) + totalExpandView;
                    all.push({ $item, iopts, ioptsg, nodeId: ioptsg.nodeId });
                }
            });
            debug('---int-h-clps:' + context.nodeId + ', - rel:' + cllpsg.relatedIds.length, { all, cllpsg });
        }
        context.all = all;
        context.freeSpace = 0;
        all.forEach(x => {
            const { iopts } = x;
            iopts.totalExpandView = totalExpandView;
            if (!iopts.relatedIds.length) iopts.relatedIds = cllpsg.relatedIds;
            const isHorizontal = iopts.Setup && iopts.Setup.Mode === 'horizontal';
            if (iopts.IsEnabled && !iopts.isExpanded && isHorizontal)
                context.freeSpace += iopts.viewport - (iopts.isZeroLength ? 0 : iopts.collapsedViewport);
        });
    };
    function refreshCollapsingHItems(context) {
        return new Promise((onOk, onErr) => {
            const rstate = { isFirst: true, isLast: false, collapsed: 0, expanded: 0, resized: 0 };
            context.all.forEach((x, ix) => {
                const { $item, iopts } = x;
                if (!$item)
                    return;

                iopts.size = { wb: $item.outerWidth(), hb: $item.outerHeight() };
                iopts.newViewport = XPortal.Utils.getViewportStateForCurrentResolution($item.attr('class'), context.cllpsg.viewportPrefix);
                if (!iopts.IsEnabled) {
                    refreshHResize(context, x, rstate);
                    iopts.size.wa = $item.outerWidth();
                    rstate.resized++;
                } else if (iopts.isExpanded) {
                    refreshHExpanded(context, x, rstate);
                    iopts.size.wa = $item.outerWidth();
                    if (context.cllpsg.Animated && context.$item[0].id === x.nodeId.toString()) refreshHCollapsed(context, x, rstate);
                    rstate.expanded++;
                } else if (!iopts.isExpanded && iopts.Setup.Mode === 'vertical') {
                    iopts.size.wa = null;
                } else {
                    refreshHCollapsed(context, x, rstate);
                    iopts.size.wa = $item.outerWidth();

                    if (context.cllpsg.Animated && context.$item[0].id === x.nodeId.toString()) refreshHExpanded(context, x, rstate);
                    rstate.collapsed++;
                }
                Object.assign(rstate, { isFirst: false, isLast: ix => context.resizable.length - 1 });
            });
            context.rstate = rstate;
            animateHCollapsing(context).then(function () {
                context.all.forEach((x) => {
                    const { $item, iopts } = x;
                    if (!$item) return;

                    if (iopts.isExpanded)
                        $item.css({ 'width': '', 'height': '' });
                    else {
                        $item.css({ 'width': iopts.size.wa, 'height': '' });
                    }
                });
                afterHAnimationProcess(context);
                onOk();
            });
        });
    };
    function animateVCollapsing(action, raction) {
        const context = this;
        return new Promise((onOk, onErr) => {
            context.content[action](context.cllpsg.animationTime, function () {
                action === 'slideUp' ? context.$item.removeClass('expanded').addClass('collapsed')
                    : context.$item.removeClass('collapsed').addClass('expanded');
                updateOverflowV('visible', context.content, context.summaryE, context.summaryC);
                XPortal.Main.RecalculateContentElementsSizes(context.$item, 0);
                onOk();
            });
            context.summaryC[raction](0);
            context.summaryE[action](0);
        });
    };
    function animateHCollapsing(context) {
        return new Promise((onOk, onErr) => {
            const { cllpsg } = context;
            let $item = context.$item;

            if (!cllpsg.Animated) return onOk();

            const minWa = self.minWa;
            let alreadyChanged = false;
            let waitingToComplt = context.all.length;
            context.all.forEach((x, ix) => {
                if (x.iopts.size.wb !== x.iopts.size.wa) {
                    x.$item.css({ 'width': x.iopts.size.wb, 'height': x.iopts.size.hb, 'flex-basis': 'auto' });
                    x.$item.removeClass('bg-transparent').addClass('hide-btns');
                    let wa = x.iopts.size.wa == 1 ? minWa : x.iopts.size.wa;
                    if (!alreadyChanged && wa != minWa) {
                        alreadyChanged = true;
                        wa = x.iopts.size.wa - minWa * (context.all.filter(x => (x.iopts.size.wa == 1)).length);
                    }
                    x.$item.animate({ 'width': wa }, cllpsg.animationTime - (x.iopts.size.wb > x.iopts.size.wa ? cllpsg.animationTime * 0.1 : 0), function () {
                        x.$item.css({ 'max-width': '', 'flex-basis': '', 'height': '' });
                        x.iopts.size.wa === minWa && x.$item.addClass('bg-transparent');
                        if ($item[0].id === x.nodeId.toString()) {
                            if (!x.iopts.IsEnabled) {
                                refreshHResize(context, x, rstate);
                            } else if (x.iopts.isExpanded) {
                                refreshHExpanded(context, x, context.rstate);
                            }
                            else {
                                refreshHCollapsed(context, x, context.rstate, minWa);
                            }
                        }
                        x.$item.removeClass('hide-btns');
                        waitingToComplt-- && waitingToComplt < 1 && onOk();
                    });
                } else {
                    x.iopts.size.wa === minWa && x.$item.addClass('bg-transparent');
                    if ($item[0].id === x.nodeId.toString()) {
                        if (!x.iopts.IsEnabled) {
                            refreshHResize(context, x, rstate);
                        } else if (x.iopts.isExpanded) {
                            refreshHExpanded(context, x, context.rstate);
                        }
                        else {
                            refreshHCollapsed(context, x, context.rstate);
                        }
                    }
                    waitingToComplt-- && waitingToComplt < 1 && onOk();
                }
            });
        });
    };
    function updateOverflowV(overflow, ...items) {
        for (var i = 0; i < items.length; i++)
            items[i].css('overflow', overflow);
    };
    function refreshHCollapsed(context, citem, state, minWidth) {
        const { header, btn } = context;
        const { $item, iopts } = citem;

        $item.removeClass(iopts.collpsdVPCss).removeClass(iopts.startupVPCss);
        cleanupStaleColClasses($item, iopts, iopts.isZeroLength ? null : iopts.collapsedViewportCss);
        if (!iopts.isZeroLength) $item.addClass(iopts.collapsedViewportCss);
        else $item.css({ 'width': minWidth ? minWidth : 1 }).addClass('collapsed-width-zero').addClass('bg-transparent');

        btn.addClass('btn-primary').attr('title', header.find('h2').text().trim()).hide();
        btn.css({ 'display': 'flex' });
        context.summaryC.slideUp(0);
        context.summaryE.slideDown(0);
        updateOverflowH(true, $item);
    };
    function refreshHExpanded(context, citem, state) {
        const { header, btn } = context;
        const { $item, iopts } = citem;
        cleanupStaleColClasses($item, iopts, null);

        $item.removeClass(iopts.collapsedViewportCss).addClass(iopts.startupVPCss);
        $item.css({ 'width': '', 'paddingLeft': '', 'paddingRight': '' }).removeClass('collapsed-width-zero').removeClass('bg-transparent');
        btn.removeClass('btn-primary').removeAttr('title').css({ 'display': 'flex' });
        context.summaryC.slideDown(0);
        context.summaryE.slideUp(0);
        updateOverflowH(false, $item);
    };
    function cleanupStaleColClasses($item, iopts, exceptCls) {
        const colClassRx = /^col-(xl|lg|md|sm|xs)-\d+$|^col-\d+$/;
        const currentClasses = ($item.attr('class') || '').split(/\s+/);
        currentClasses.forEach(function (cls) {
            if (colClassRx.test(cls) && cls !== exceptCls && iopts.designClasses && iopts.designClasses.indexOf(cls) === -1) {
                $item.removeClass(cls);
            }
        });
    };
    function refreshHResize(context, citem, state) {
        const { cllpsg } = context;
        const { $item, iopts } = citem;

        const isTablet = window.innerWidth < 992;
        if (!context.isInit && isTablet && !context.skipTabletGuard) {
            return;
        }

        const viewPort = iopts.viewport;
        const closedBefore = -1;
        const closedAfter = -1;
        const sectionAddWidth = calcSectionHWidth(context, iopts, state);

        let totalCols = viewPort + sectionAddWidth;
        if (totalCols > 12) totalCols = 12;

        const newCss = XPortal.Utils.createViewportCssClass(cllpsg.viewportPrefix, totalCols);

        cleanupStaleColClasses($item, iopts, newCss);

        $item.addClass(newCss);
        iopts.lastAppliedResizeClass = newCss;

        $item.css({ 'margin-left': closedBefore != 0 ? closedBefore : '', 'margin-right': closedAfter != 0 ? closedAfter : '' });
    };
    function updateOverflowH(forCollps, ...items) {
        if (forCollps) {
            for (var i = 0; i < items.length; i++)
                items[i].addClass('collapsed-hidden').css({ 'flex': 'none' });
        } else {
            for (var i = 0; i < items.length; i++)
                items[i].removeClass('collapsed-hidden').css({ 'flex': '' });
        }
    };
    function calcSectionHWidth(context, iopts, state) {
        let result = 0;
        if (context.freeSpace <= 0) return 0;
        let remainder = context.freeSpace;
        const proportion = iopts.viewport / iopts.totalExpandView;
        result = Math.round(remainder * proportion);
        if (remainder > 0 && result < 1) result = 1;

        remainder -= result;
        if (state.isLast) {
            result = remainder < 0 ? result - remainder : result + remainder;
            remainder = 0;
        }

        context.freeSpace = remainder;
        return result;
    };
    function afterHAnimationProcess(context) {
        const { all, $item, cllpsg } = context;

        let first = all[0].$item;
        let last = all[all.length - 1].$item;
        if (!first || !last || !$item)
            return;

        all.forEach(x => {
            if (!x.iopts.IsEnabled) return
            const $this = x.$item;
            $this.removeClass('first').removeClass('last');
            const actionName = x.iopts.isExpanded ? 'removeClass' : 'addClass';
            const $prev = $this.prev();
            const $next = $this.next();
            $prev[actionName]('next-collapsed-width-zero');
            $next[actionName]('prev-collapsed-width-zero');

            if ($this.hasClass('collapsed-width-zero')) {
                $this.removeClass('prev-collapsed-width-zero').removeClass('next-collapsed-width-zero');
            }
        });

        first.addClass('first');
        last.addClass('last');
        first.prev().removeClass('next-collapsed-width-zero');
        last.next().removeClass('prev-collapsed-width-zero');

        XPortal.Main.RecalculateContentElementsSizes($item.parent(), 100);
    };
    function refreshMinMax(context) {
        const { $item, maxsg, hasScheduler, btnMax, btnMin, btnCollps } = context;
        const isItemInPopup = $item.closest('.popup-detail-content').length > 0;
        
        if (!maxsg.isMaximized) {
            $item.next('.fake-element').remove();
            $item.css({ 'top': '', 'bottom': '', 'left': '' });
            if (hasScheduler && maxsg.outerHeight)
                $item.css({ 'height': parseInt(maxsg.outerHeight) });

            $item.removeClass('maximized');
            $('body').removeClass(`has-maximized-${maxsg.Mode}`);
            if (btnCollps.hasClass("hidden-maximized")) {
                btnCollps.removeClass('d-none');
                btnCollps.removeClass('hidden-maximized');
            }
        } else {
            $item.after($(`<div class="fake-element col" style="width:${$item.outerWidth(true)}px;height:${$item.outerHeight(true)}px;"></div>`));
            maxsg.outerHeight = $item.outerHeight();
            if (maxsg.Mode == 'site' && isItemInPopup == 0)
                $item.css({
                    'top': $('header').outerHeight(), 'bottom': 0, 'left': $('body').hasClass('desktop-menu-opened') ? $('.sidebar').outerWidth() : 0
                });

            if (maxsg.Mode !== 'wrapper')
                $('body').addClass(`has-maximized-${maxsg.Mode}`);

            $item.addClass('maximized');
            if (btnCollps.is(":visible")) {
                btnCollps.addClass('d-none');
                btnCollps.addClass('hidden-maximized');
            }
        };
    };

    function debug(m, args) {
        return;
        console.log(m, args);
    };
    return self;
}());